import { render, staticRenderFns } from "./CourseView.vue?vue&type=template&id=4de5ccec&scoped=true"
import script from "./CourseView.vue?vue&type=script&lang=js"
export * from "./CourseView.vue?vue&type=script&lang=js"
import style0 from "./CourseView.vue?vue&type=style&index=0&id=4de5ccec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5ccec",
  null
  
)

export default component.exports